import { environment } from './environment';

const url = environment.url;

export const endpoints = {
  apolices: `${url}/apolices`,
  apolicesDocumentos: `${url}/apolices-documentos`,
  auth: `${url}/auth`,
  banners: `${url}/banners`,
  beneficiaries: `${url}/beneficiaries`,
  chamados: `${url}/solicitations`,
  solicitationMessages: `${url}/solicitations/messages`,
  client: `${url}/client`,
  coparticipation: `${url}/coparticipations`,
  consentForm: `${url}/consent`,
  contractDocuments: `${url}/contract-documents`,
  contracts: `${url}/contracts`,
  cookies: `${url}/cookies`,
  dischargeDebtLetter: `${url}/dischargeDebtLetter`,
  dpsQuestions: `${url}/dpsQuestions`,
  enterprise: `${url}/enterprise`,
  faq: `${url}/faq`,
  faturasOperadoras: `${url}/faturas-operadoras`,
  rateioFaturamento: `${url}/rateio-faturamento`,
  filaIntegracao: `${url}/painel-integracoes`,
  immediateCancellation: `${url}/immediateCancellation`,
  importacaoMovimentacao: `${url}/importacoesMovimentacao`,
  incomeReport: `${url}/incomeReport`,
  invoice: `${url}/invoice`,
  kinships: `${url}/kinships`,
  lockTypes: `${url}/lockTypes`,
  solicitationsFollowUp: `${url}/solicitations/follow-up`,
  motivos: `${url}/beneficiaries/list-motivos`,
  plans: `${url}/plans`,
  uploads: `${url}/uploads`,
  users: `${url}/users`,
  userProfiles: `${url}/userProfiles`,
};
